import React, { createContext, useContext, useMemo, useState } from 'react';

type DateContextValue = {
  selectedDate: string;
  setSelectedDate: (date: string) => void;
};

const DateContext = createContext<DateContextValue | undefined>(undefined);

const getToday = (): string => new Date().toISOString().split('T')[0];

// No persistence; always start with today's date

export const DateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedDate, setSelectedDateState] = useState<string>(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const urlDate = params.get('date');
      if (urlDate && /^\d{4}-\d{2}-\d{2}$/.test(urlDate)) return urlDate;
    } catch {}
    // Default: always start with today's date
    return getToday();
  });

  // No URL/localStorage synchronization – date is managed only in memory

  const value = useMemo<DateContextValue>(() => ({
    selectedDate,
    setSelectedDate: (d: string) => {
      console.log('[DateContext] setSelectedDate called with:', d, 'current:', selectedDate);
      if (!d || !/^\d{4}-\d{2}-\d{2}$/.test(d)) {
        console.log('[DateContext] Invalid date, ignoring');
        return;
      }
      console.time('[DateContext] setSelectedDateState');
      setSelectedDateState(d);
      console.timeEnd('[DateContext] setSelectedDateState');
      console.log('[DateContext] Date state updated to:', d);
    }
  }), [selectedDate]);

  return (
    <DateContext.Provider value={value}>
      {children}
    </DateContext.Provider>
  );
};

export const useDate = (): DateContextValue => {
  const ctx = useContext(DateContext);
  if (!ctx) throw new Error('useDate must be used within a DateProvider');
  return ctx;
};


